exports.api = {
    login: `admin/login`,
    logout: `admin/logout`,
    profile: `user/profile`,
    updateProfile: `admin/update`,
    changePassword: `change-password`,
    dashboard: `admin/dashboard`,
    dashboardGraph: `admin/payment-graph`,
    userList: `admin/user-list`,
    userDetail: `user/detail/`,
    userChangeStatus: `admin/user-status/`,
    stateList: `state/list`,
    providerList: `admin/provider-list`,
    providerDetail: `provider/detail/`,
    moreProvider: `admin/plan/subscribed/provider-list`,
    providerChangeStatus: `admin/provider/status/`,
    registrationList: `admin/provider/registration/request-list`,
    categoryList: `category/list`,
    addCategory: `category/add`,
    updateCategory: `category/update/`,
    deleteCategory: `category/delete/`,
    postedJobList: `admin/posted/job-list`,
    postedJobDetail: `provider/posted/job/detail/`,
    postedChangeStatus: `admin/posted/job/status/`,
    careJobList: `admin/care/job-list`,
    careJobDetails: `admin/care/job-detail/`,
    planList: `admin/plan`,
    addPlan: `admin/plan`,
    deletePlan: `admin/plan/delete/`,
    updatePlan: `admin/plan/update/`,
    advertisement: `advertisement/list`,
    deleteAdvertisement: `advertisement/delete/`,
    updateAdvertisement: `advertisement/update/`,
    addAdvertisement: `advertisement/add`,
    advertisementDetail: `advertisement/details/`,
    advertisementChangeStatus: `admin/advertisement/status/`,
    tagsList: `tag/list`,
    newsletterList: `newsletter/subscriber-list`,
    newsletterChangeStatus: `admin/newsletter/status/`,
    sendMail: `admin/newsletter/send-email`,
    sendText: `admin/newsletter/send-text`,
    sendNewEmail: `admin/newsletter/send/email`,
    sendNewText: `admin/newsletter/send/text`,
    assessmentList: `admin/care/assessment/requests/in-Home`,
    sendRequestProvider: `admin/send/request-to-provider`,
    couponList: `admin/coupon/list`,
    couponDelete: `admin/coupon/`,
    couponCreate: `admin/coupon`,
    couponUpdate: `admin/coupon/`,
    paymentLogs: `admin/payment/logs`,
    nonSubscription: `admin/non-susbcription`,

    couponLoyaltyType: `coupon/loyalty/`,
    employeeList: `sub/admin/list`,
    employeeCreate: `sub/admin/add`,
    employeeUpdate: `sub/admin/update/`,
    employeeDelete: `sub/admin/delete/`,

    blogList: `blog/list`,
    blogCreate: `blog/add`,
    blogDelete: `blog/delete/`,
    blogUpdate: `blog/update/`,
    blogDetails: `blog/detail/`,
    
};